<template>
  <b-modal
    :id="id"
    title="Payment Method"
    hide-footer
    centered
    @cancel="close()"
    @close="close()"
    @hide="close()"
  >
    <div>
      <b-button
        variant="primary"
        block
        @click.prevent="navigateToBookingPayment"
      >
        <b-spinner
          v-if="navigatingToBookingPayment"
          variant="light"
          style="height: 20px; width: 20px;"
          label="Navigating to Booking Payment"
        ></b-spinner>
        <div v-else>
          Go to Payment
        </div>
      </b-button>
      <button class="btn btn-light btn-block" @click="tryMarkBookingAsPaid">
        Mark as Paid
      </button>
    </div>
  </b-modal>
</template>
<script>
import { mapActions } from 'vuex';
import { checkoutBookingForAdmin } from '@/stripe';

export default {
  props: {
    id: String,
    booking: Object
  },
  data() {
    return {
      navigatingToBookingPayment: false
    };
  },
  methods: {
    ...mapActions({
      markBookingAsPaid: 'bookings/markBookingAsPaid'
    }),
    async navigateToBookingPayment() {
      this.navigatingToBookingPayment = true;

      try {
        await checkoutBookingForAdmin(this.booking._id, this.booking.storeId);
        this.close();
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      } finally {
        this.navigatingToBookingPayment = false;
      }
    },
    async tryMarkBookingAsPaid() {
      try {
        await this.markBookingAsPaid(this.booking);
        this.close();
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
